import { ControlPosition } from '@xyflow/react';

export const calculateIsResizingHorizontal = (position: ControlPosition | null) => {
  return position === 'left' || position === 'right';
};

export const findNearestAllowedValue = (value: number, allowedValues: number[]): number => {
  if (allowedValues.length === 0) return value;

  let nearest = allowedValues[0];
  let minDiff = Math.abs(value - nearest);

  for (let i = 1; i < allowedValues.length; i++) {
    const diff = Math.abs(value - allowedValues[i]);
    if (diff < minDiff) {
      minDiff = diff;
      nearest = allowedValues[i];
    }
  }

  return nearest;
};
